import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { LicenseService } from './resolvers/license/license.service';
import { UserDetailsService } from './resolvers/userData/users-details.service';
import { CartTotalService } from './resolvers/cart/cart.service';
import { BillingAddressResolverService } from './resolvers/billing-address/billing-address-resolver.service';
import { SubscriptionResolverService } from './resolvers/subscription/subscription.resolver.service';
import { NotificationResolverService } from './resolvers/notification/notification.resolver.service';
import { domainCheckGuardGuard } from './guards/DomainCheckGuard/domain-check-guard.guard';
import { ComingSoonComponent } from './components/coming-soon/coming-soon.component';
import { ComingSoonGuard } from './guards/coming-soon/coming-soon.guard';
import { PlatformSaleResolver } from './resolvers/platform-sale/platform-sale-resolver.service';
import { SupportRedirectComponent } from './components/support-redirect/support-redirect.component';


const routes: Routes = [
  {path: '', redirectTo: '', pathMatch: 'full'},
  {
    path: 'support',
    component: SupportRedirectComponent
  },
  {
    path: '',
    loadChildren: () => import(
      "./lazy-load-modules/layout-module/layout.module").
      then((m) => m.LayoutModule),
      resolve: {
        licData: LicenseService,
        userData: UserDetailsService,
        cartData: CartTotalService,
        billingAddress: BillingAddressResolverService,
        activatedSubscription: SubscriptionResolverService,
        notificationRes: NotificationResolverService,
        platformSaleData: PlatformSaleResolver
      },
      canActivate: [domainCheckGuardGuard]
  },
  {
    path:'error',
    component: ErrorPageComponent,
    data : { title: "Error" },
    canActivate: [domainCheckGuardGuard]
  },
  {
    path:'coming-soon',
    component: ComingSoonComponent,
    data : { title: "Coming Soon" },
    canActivate: [ComingSoonGuard]
  },
  {
    path:'**',
    redirectTo:'error',
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
